import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';
import buttonMixin, { ButtonMixinProps } from './buttonMixin';

/* eslint-disable @typescript-eslint/no-unused-vars */
const LinkPropsWrapper = ({
  xs,
  sm,
  md,
  rect,
  primary,
  secondary,
  children,
  ...props
}: ButtonMixinProps & LinkProps) => <Link {...props}>{children}</Link>;

const LinkButton = styled(LinkPropsWrapper)<ButtonMixinProps>`
  ${buttonMixin}
  text-decoration: none;
  :focus,
  :hover {
    text-decoration: none;
  }
`;

export default LinkButton;
